import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BlockModel } from 'src/app/core/models/BlockModel';
import { CompanyModel } from 'src/app/core/models/CompanyModel';
import { DepartmentModel } from 'src/app/core/models/DepartmentModel';
import { PriorityLevelEnum, PriorityLevelMapping } from 'src/app/core/models/PriorityLevelEnum';
import { QueryCategoryModel } from 'src/app/core/models/QueryCategoryModel';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QuerySubCategoryModel } from 'src/app/core/models/QuerySubCategoryModel';
import { ReportFilterModel } from 'src/app/core/models/ReportFilterModel';
import { ReportModel } from 'src/app/core/models/ReportModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { User } from 'src/app/core/models/user';
import { ReportService } from '../report.service';
import { UserService } from 'src/app/core/services/user.service';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { XlsxService } from 'src/app/shared/services/xlsx.service';
import { AdminService } from '../../admin/admin.service';
import { ClarificationQueryListService } from '../../clarification-query/clarification-query-list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KayValuePair } from 'src/app/core/models/KayValuePair';


@Component({
  selector: 'app-report',
  standalone: false,
  templateUrl: './report.component.html',
  styleUrl: './report.component.less'
})
export class ReportComponent implements OnInit {
  
  currentUser: User = new User();
  reportFilter: ReportFilterModel = new ReportFilterModel();
  priorityLevelMapping = PriorityLevelMapping;
  priorityLevels = Object.values(PriorityLevelEnum);

  output: any;
  blockMaster: BlockModel[] = [];
  companyMaster: CompanyModel[] = [];
  departmentMaster: DepartmentModel[] = [];
  subDeptMaster: SubDepartmentModel[] = [];
  deptSubDeptMaster: SubDepartmentModel[] = [];
  categoryMaster: QueryCategoryModel[] = [];
  subCatMaster: QuerySubCategoryModel[] = [];
  catSubCatMaster: QuerySubCategoryModel[] = [];
  //partnerUserMaster: RegisteredUserModel[];
  queryStatusMaster: { Status_Code: any; Status_Name: string }[] = [];
  allUsers: User[] = [];
  requestorEmails: KayValuePair[] = [];
  requestorNames: KayValuePair[] = [];

  //displayDeptFilter = false;
  selectedNameIds = [];
  selectedEmailIds = [];
  selectedCreatedByIds = [];
  dropdownSettings = {};

  reportData: ReportModel[] = [];
  viewReportDetails = false;
  config: any;
  currentPageSize = 10;
  sortingName: string = "";
  isDesc: boolean = false;

  exportData: { Title: string; Data: any[]; Headers: string[] }[] = [];

  viewGrid = true;
  queryReferenceNumber = "";
  subject="";
  requestStatus = "";
  partnerUserMaster: { item_id: any; item_text: string }[] = [];
  CCSubDepartmentsMaster: { item_id: any; item_text: string }[] = [];
  queryDetail: QueryDetailModel = new QueryDetailModel();
  reportForm!: FormGroup;
  isMasterDataLoaded: boolean = false;
  isCollapse: boolean = true;

  constructor(private router: Router,
    private datepipe: DatePipe,
    private messageService: NzMessageService,
    private reportService: ReportService,
    private userService: UserService,
    private dbMasterService: DbMasterService,
    private xlxsService: XlsxService,
    //private dateConfig: NgbDatepickerConfig,
    private adminService: AdminService,
    private queryService: ClarificationQueryListService,   
    private fb: FormBuilder 
  ) { 
    var maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 2);
    //dateConfig.minDate = { year: 2021, month: 1, day: 1 };
    //dateConfig.maxDate = { year: maxDate.getFullYear() , month: maxDate.getMonth(), day: maxDate.getDate() };
  }
  ngOnInit(): void {
    this.initializeForm();
    this.initialiseData();
  }
  private initializeForm(): void {
    this.reportForm = this.fb.group({
      RequestNumber: ['', [Validators.maxLength(25)]],
      Subject: ['', [Validators.maxLength(80)]],
      RequestorName: [null],
      RequestorEmail: [null],
      CreatedBy: [null],
      RequestStatus: [0],
      Confidential: ['0'],
      PriorityLevel: [0],
      ReqStartDt: [null],
      ReqEndDt: [null],
      Company: [0],
      Block: [0],
      Department: [0],
      SubDepartment: [0],
      QueryCat: [0],
      QuerySubCat: [0],
      LetterRefNum: ['', [Validators.maxLength(25)]],
      ContractNum: ['', [Validators.maxLength(25)]],
      WONum: ['', [Validators.maxLength(25)]],
      AFENumber: ['', [Validators.maxLength(25)]],
      CompanyRestricted: ['0']
    });
  }
  initialiseData() {
    // this.queryStatusKeys=Object.keys(this.queryStatus).filter(f => !isNaN(Number(f)));
    this.isMasterDataLoaded = false;
    this.setFilterData();
    this.dbMasterService.getMasterDetails(true).subscribe(response => {

      this.adminService.getAllSubDeptMapping(true).subscribe((response: any) => {
        if (response.output.length > 0) {
          for (var i = 0; i < response.output.length; i++) {
            this.CCSubDepartmentsMaster.push({ item_id: response.output[i].Sub_Dept_Code, item_text: response.output[i].Department_Name + ' - ' + response.output[i].Sub_Dept_Name});
          }
        }
      });

      this.output = response.output;
      this.blockMaster = this.output.Block as [];
      this.companyMaster = this.output.Company as [];
      this.departmentMaster = this.output.Department as [];
      this.subDeptMaster = this.output.SubDepartment as [];
      this.categoryMaster = this.output.Category as [];
      this.subCatMaster = this.output.SubCategory as [];
      this.queryStatusMaster = this.output.QueryStatus as [];

      this.requestorNames = this.output.PartnerUsers.map(function (item: any) {
        return { 'item_id': item.User_Code, 'item_text': item.User_Name };
        
      });

      this.requestorEmails = this.output.PartnerUsers.map(function (item : any) {
        return { 'item_id': item.User_Code, 'item_text': item.Email };
      });

      this.allUsers = this.output.AllUsers.map(function (item : any) {
        return { 'User_Code': item.User_Code, 'User_Name': item.User_Name };
      });

      if (this.output.PartnerUsers.length > 0) {
        for (var i = 0; i < this.output.PartnerUsers.length; i++) {
          this.partnerUserMaster.push({ item_id: this.output.PartnerUsers[i].User_Code, item_text: this.output.PartnerUsers[i].User_Name });
        }     
      }
      this.isMasterDataLoaded = true;
    });
  }
  setFilterData() {
    this.reportFilter = new ReportFilterModel();
    this.reportFilter.RequestNumber = '';
    this.reportFilter.Subject='';
    this.reportFilter.RequestStatus = 0;
    this.reportFilter.ReqStartDt = '';
    this.reportFilter.ReqEndDt = '';
    this.reportFilter.RequestorNames = '0';
    this.reportFilter.RequestorEmails = '0';
    this.reportFilter.Company = 0;
    this.reportFilter.Block = 0;
    this.reportFilter.Department = 0;
    this.reportFilter.SubDepartment = 0;
    this.reportFilter.QueryCat = 0;
    this.reportFilter.QuerySubCat = 0;
    this.reportFilter.AFENumber = '';
    this.reportFilter.LetterRefNum = '';
    this.reportFilter.ContractNum = '';
    this.reportFilter.WONum = '';
    this.reportFilter.CreatedBy = '0';
    this.reportFilter.CompanyRestricted =  this.reportFilter.Confidential=0;
    this.reportFilter.PriorityLevel = 0;
    this.catSubCatMaster = [];
    var defaultSubCat = new QuerySubCategoryModel();
    defaultSubCat.Sub_Cat_Code = "0";
    defaultSubCat.SubCatDesc = "All";
    this.catSubCatMaster.splice(0, 0, defaultSubCat)
  }
  get loadingText(): string {
    return this.isMasterDataLoaded ? 'Choose' : 'Loading... please wait'; // Change the text based on the loading state
  }
  get loadingTextAll(): string {
    return this.isMasterDataLoaded ? 'All' : 'Loading... please wait'; // Change the text based on the loading state
  }
  generateReport() {
    var filterModel = this.mapFormValuesToFilterModel();
    
    this.reportService.generateReport(filterModel).subscribe((response: any) => {
      this.reportData = response.output as ReportModel[];
      this.viewReportDetails = true;
      
      
    }, error => {
      this.messageService.error("Error occurred while generating Report. Please refresh the page and generate the report.");
      
    });
  }
  mapFormValuesToFilterModel(): ReportFilterModel {
    this.reportFilter = new ReportFilterModel();
    this.reportFilter.RequestNumber = this.reportForm.get('RequestNumber')?.value ?? '';
    this.reportFilter.Subject = this.reportForm.get('Subject')?.value ?? '';
    this.reportFilter.RequestorNames = (this.reportForm.get('RequestorName')?.value ??[0]).join(',');
    this.reportFilter.RequestorEmails = (this.reportForm.get('RequestorEmail')?.value ??[0]).join(',');
    this.reportFilter.CreatedBy = (this.reportForm.get('CreatedBy')?.value ??[0]).join(',');
    this.reportFilter.RequestStatus = this.reportForm.get('RequestStatus')?.value ?? 0;
    this.reportFilter.Confidential = this.reportForm.get('Confidential')?.value ?? 0;
    this.reportFilter.PriorityLevel = this.reportForm.get('PriorityLevel')?.value ?? 0;
    this.reportFilter.ReqStartDt = this.datepipe.transform(this.reportForm.get('ReqStartDt')?.value, 'yyyy-MM-dd') || '';
    this.reportFilter.ReqEndDt = this.datepipe.transform(this.reportForm.get('ReqEndDt')?.value, 'yyyy-MM-dd') || '';
    this.reportFilter.Company = this.reportForm.get('Company')?.value ?? 0;
    this.reportFilter.Block = this.reportForm.get('Block')?.value ?? 0;
    this.reportFilter.Department = this.reportForm.get('Department')?.value ?? 0;
    this.reportFilter.SubDepartment = this.reportForm.get('SubDepartment')?.value ?? 0;
    this.reportFilter.QueryCat = this.reportForm.get('QueryCat')?.value ?? 0;
    this.reportFilter.QuerySubCat = this.reportForm.get('QuerySubCat')?.value ?? 0;
    this.reportFilter.LetterRefNum = this.reportForm.get('LetterRefNum')?.value ?? '';
    this.reportFilter.ContractNum = this.reportForm.get('ContractNum')?.value ?? '';
    this.reportFilter.WONum = this.reportForm.get('WONum')?.value ?? '';
    this.reportFilter.AFENumber = this.reportForm.get('AFENumber')?.value ?? '';
    this.reportFilter.CompanyRestricted = this.reportForm.get('CompanyRestricted')?.value ?? 0;

    return this.reportFilter;
  }

  onDepartmentChange(department_Code: string) {
    this.deptSubDeptMaster = [];
    // Clear the subDepartment field in the form
    this.reportForm.patchValue({
      SubDepartment: ''
    });
    this.deptSubDeptMaster = this.subDeptMaster.filter(item => item.Department_Code == department_Code);    
  }
  onQueryCategoryChange(query_category_Code: string) {
    this.catSubCatMaster = [];
    // Clear the subDepartment field in the form
    this.reportForm.patchValue({
      QuerySubCat: ''
    });
    this.catSubCatMaster = this.subCatMaster.filter(item => item.Clarification_Cat_Code == query_category_Code);    
  }
  toggleCollapse(): void {
    this.isCollapse = !this.isCollapse;
  }
  resetFilter() {
    this.setFilterData();
    this.selectedNameIds = [];
    this.selectedEmailIds = [];
    this.selectedCreatedByIds = [];
    this.viewReportDetails = false;
    this.exportData = [];
    this.reportForm.reset();
  }
  showQueryDetails(selectedQuery: ReportModel)
  {
    this.queryReferenceNumber = selectedQuery.QueryRequestNumber;
    this.subject = selectedQuery.Subject;
    this.requestStatus = selectedQuery.QueryStatus;
    this.queryService.getQueryDetails(selectedQuery.QueryCode).subscribe((response: any) => {
        this.queryDetail = response.output.filter((s:any) => s.Clarification_Query_Detail_Code == selectedQuery.QueryDetailCode)[0];
        this.viewGrid = false;
    }, error => {
      this.redirectBack();
      console.log(error);
    });
  }
  redirectBack()
  {
    this.viewGrid = true;
    this.queryReferenceNumber = "";
    this.subject='';
    this.requestStatus = "";
    this.queryDetail = new QueryDetailModel();
  }
  exportToExcel() {    
    let currentDate = new Date();
    let exportData = [];
    let headers = ["Reference Number",
      "Subject",
      "Request Status",
      "Requestor Name",
      "Requestor Email",
      "Priority",
      "Confidential",
      "Company",
      "Request Date",
      "Responded Date",
      "Block",
      "Department",
      "Sub Department",
      "Company Restricted",
      "Category",
      "Sub Category",
      "AFE Number",
      "Letter Reference Number",
      "Contract Number",
      "Work Order Number",
      "Due Date",
      "Category Comments",
      "Partner Comment",
      "Resolution Comment",
      "Delete Comment",
      "Request Created By"
    ];

    exportData = this.reportData.map(function (item) {
      return {
        "Reference Number": item.QueryRequestNumber,
        "Subject": item.Subject,
        "Request Status": item.QueryStatus,
        "Requestor Name": item.RequestorName,
        "Requestor Email": item.RequestorEmail,
        "Priority" : item.Priority,
        "Confidential" : item.Confidential,
        "Company": item.Company,
        "Request Date": item.RequestedDate,
        "Responded Date": item.RespondedDate,
        "Block": item.Block,
        "Department": item.Department,
        "Sub Deptartment": item.SubDeptartment,
        "Company Restricted": item.CompanyRestricted,
        "Category": item.Category,
        "Sub Category": item.SubCategory,
        "AFE Number": item.AFENumber,
        "Letter Reference Number": item.LetterReferenceNumber,
        "Contract Number": item.ContractNumber,
        "Work Order Number": item.WorkOrderNumber,
        "Due Date" : item.QueryReqDueDate,
        "Category Comments": item.CategoryComments,
        "Partner Comment": item.PartnerComment,
        "Resolution Comment": item.ResolutionComment,
        "Delete Comment": item.DeleteComment,
        "Request Created By": item.CreatedByUserName
      };
    });

    this.exportData.push({ Title: 'Reports', Data: exportData, Headers: headers });
    this.xlxsService.export(this.exportData, "Reports_" + this.datepipe.transform(currentDate, 'dd-MMM-yyyy'));

    
    this.exportData = [];
  }
  
}
